import { QuestionStyle } from './enums';
import { type Question } from './types';

export const steps: Question[] = [
  {
    id: 'industry',
    style: QuestionStyle.RadioBoxes,
    layout: {
      className: 'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2'
    },
    data: {
      conditional: false,
      options: [
        'financial_services',
        'marketing',
        'property_management',
        'software',
        'professional_services',
        'education',
        'government',
        'manufacturing',
        'retail',
        'healthcare',
        'non_profit',
        'construction'
      ],
      other: true
    }
  },
  {
    id: 'use_case',
    style: QuestionStyle.RadioBoxes,
    layout: {
      className: 'flex flex-col sm:flex-row',
      grid: [
        [0, 1, 2, 3],
        [4, 'other']
      ]
    },
    data: {
      conditional: true,
      options: {
        financial_services: [
          'payroll-and-timecards',
          'quotes-and-invoices',
          'security-policy-management',
          'custom-crm',
          'not_sure_yet'
        ],
        marketing: [
          'event-management',
          'digital-asset-management',
          'publishing-management',
          'customer-portal',
          'not_sure_yet'
        ],
        manufacturing: [
          'custom-crm',
          'customer-portal',
          'inventory-management',
          'product-catalog',
          'not_sure_yet'
        ],
        property_management: [
          'property-management',
          'real-estate-listings',
          'quotes-and-invoices',
          'custom-crm',
          'not_sure_yet'
        ],
        retail: [
          'customer-payment-portal',
          'inventory-management',
          'project-management',
          'custom-crm',
          'not_sure_yet'
        ],
        software: [
          'customer-portal',
          'project-management',
          'custom-crm',
          'employee-reviews',
          'not_sure_yet'
        ],
        healthcare: [
          'patient-portal',
          'patient-scheduling',
          'practice-management-system',
          'electronic-medical-records',
          'not_sure_yet'
        ],
        professional_services: [
          'customer-portal',
          'inventory-management',
          'project-management',
          'quotes-and-invoices',
          'not_sure_yet'
        ],
        non_profit: [
          'customer-portal',
          'custom-crm',
          'volunteer-management',
          'donations-management',
          'not_sure_yet'
        ],
        education: [
          'parent-and-student-portal',
          'event-calendar',
          'learning-management-system',
          'school-management',
          'not_sure_yet'
        ],
        construction: [
          'construction-management',
          'construction-estimate-app',
          'field-service-manager',
          'custom-crm',
          'not_sure_yet'
        ],
        government: [
          'budget-and-expense-management',
          'government-procurement-and-contracts',
          'municipal-payments-portal',
          'government-public-service-and-works',
          'not_sure_yet'
        ],
        other: [
          'customer-portal',
          'custom-crm',
          'project-management',
          'member-directory',
          'not_sure_yet'
        ]
      },
      other: true
    }
  },
  {
    id: 'user_type',
    style: QuestionStyle.RadioBoxes,
    layout: {
      className: 'grid grid-cols-1'
    },
    data: {
      conditional: false,
      options: ['pen_and_paper', 'spreadsheets', 'no_code_tools', 'developer'],
      other: false
    }
  }
];
